export const REFERRAL_BASE = '/invite'

export const referralPlansPath = (code?: string) =>
  code ? `${REFERRAL_BASE}/${code}/plans` : `${REFERRAL_BASE}/plans`
